import React from 'react';
import { createDownloadLatestDocumentUrl } from '../../../../../../../API/order/documents/adminDocumentsAPI';
import { ISigningAppointmentDocumentResponse } from '../../../../../../../types/signingAppointment/ISigningAppointmentDocumentResponse';
import { Tooltip } from 'ui-toolkit';
import { useSelectAppointmentFromPathParam } from '../../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { TrashAndBadges } from './TrashAndBadges';

export const OutgoingItem: React.FC<{
  document: ISigningAppointmentDocumentResponse;
  setPreviewDoc: (docUrl: string) => void;
}> = ({ document, setPreviewDoc }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const isSignatureSyncAppointment = appointmentFromPath?.isSignatureSyncAppointment;

  return (
    <div className={'flex flex-row items-center justify-between gap-2'}>
      <button
        className={'shrink cursor-pointer truncate text-blue-600'}
        onClick={(event) => {
          event.stopPropagation();
          setPreviewDoc(createDownloadLatestDocumentUrl(document.standardDocument.id));
        }}
      >
        <Tooltip
          tooltipContent={document.standardDocument.fileFileName}
          trigger="hover"
          placement="top"
          triggerClassname="truncate"
        >
          {document.standardDocument.fileFileName ?? ''}
        </Tooltip>
      </button>
      <TrashAndBadges isSignatureSyncAppointment={isSignatureSyncAppointment} document={document} />
    </div>
  );
};
